import { ActiveModel } from '@alt-point/active-models/src'
import {
  definePayloadPlugin,
  definePayloadReducer,
  definePayloadReviver,
} from 'nuxt/app'

export default definePayloadPlugin(function () {
  // region ActiveModel
  definePayloadReducer('ActiveModel', (value) => {
    if (!(value instanceof ActiveModel)) {
      return
    }

    return value.toJSON()
  })
  definePayloadReviver('ActiveModel', value => value)
  // endregion
})
